import { createI18n } from "vue-i18n";
import type { I18nOptions } from "vue-i18n";

function loadLocaleMessages() {
  const locales = require.context("../Locales", true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {} as I18nOptions["messages"];
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    //console.log(matched);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages![locale] = locales(key).default;
    }
  });
  return messages;
}

export default createI18n({
  locale: "en",
  fallbackLocale: "en",
  legacy: false,
  globalInjection: true,
  messages: loadLocaleMessages(),
});
